import React from 'react'
import { useQuery, gql } from '@apollo/client'
import { withTranslation, useTranslation } from 'react-i18next'
import { Container, Box, Typography, Button, Grid } from '@mui/material'
import CreditCardRounded from '@mui/icons-material/CreditCardRounded'
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded'
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded'
import OpenInNewRounded from '@mui/icons-material/OpenInNewRounded'
import ChecklistRounded from '@mui/icons-material/ChecklistRounded'
import { SectionCard, raisedButtonSx } from '../components/UI/Depth'
import { toneTile } from '../utils/depth'
import Header from '../components/Headers/Header'
import ConfigurableValues from '../config/constants'
import { getRestaurantProfile } from '../apollo'
const RESTAURANT = gql`
  ${getRestaurantProfile}
`
const Payment = () => {
  const { SERVER_URL } = ConfigurableValues()

  const { t } = useTranslation()

  const restaurantId = localStorage.getItem('restaurantId')

  const { data, error: errorQuery, loading: loadingQuery } = useQuery(
    RESTAURANT,
    {
      variables: { id: restaurantId }
    }
  )
  const submitStripeDetails = () => {
    fetch(SERVER_URL + '/stripe/account', {
      method: 'POST',
      body: JSON.stringify({ restaurantId }),
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        window.location = data.url
      })
      .catch(error => {
        console.log('error', error)
      })
  }
  const connected = !!(data && data.restaurant.stripeDetailsSubmitted)
  const steps = [
    t('StripeStepAccount'),
    t('StripeStepBank'),
    t('StripeStepPayouts')
  ]
  return (
    <>
      <Header />
      <Container disableGutters maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <SectionCard
              icon={CreditCardRounded}
              tone="violet"
              title={t('StripePayouts')}
              subtitle={t('StripePayoutsHelp')}
              bodySx={{ pt: 3 }}>
              {errorQuery && (
                <Typography sx={{ color: 'error.main', mb: 2 }}>
                  {errorQuery.message}
                </Typography>
              )}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  p: 2,
                  mb: 3,
                  borderRadius: '14px',
                  bgcolor: connected ? 'success.light' : 'grey.100',
                  boxShadow: 'inset 0 1px 3px rgba(16,24,40,0.06)'
                }}>
                {connected ? (
                  <CheckCircleRounded sx={{ color: 'success.main' }} />
                ) : (
                  <ErrorOutlineRounded sx={{ color: 'text.disabled' }} />
                )}
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                    {loadingQuery
                      ? t('LoadingDots')
                      : connected
                      ? t('StripeDetailsAttached')
                      : t('StripeNotConnected')}
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                    {connected
                      ? t('StripeConnectedHelp')
                      : t('StripeNotConnectedHelp')}
                  </Typography>
                </Box>
              </Box>
              <Button
                disabled={loadingQuery}
                onClick={submitStripeDetails}
                endIcon={<OpenInNewRounded />}
                sx={raisedButtonSx}>
                {connected ? t('EditStripeDetails') : t('SubmitStripeDetails')}
              </Button>
            </SectionCard>
          </Grid>
          <Grid item xs={12} md={5}>
            <SectionCard
              icon={ChecklistRounded}
              tone="slate"
              title={t('HowItWorks')}
              bodySx={{ pt: 2 }}>
              {steps.map((step, index) => (
                <Box
                  key={step}
                  sx={{
                    display: 'flex',
                    gap: 1.5,
                    alignItems: 'center',
                    py: 1
                  }}>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 13,
                      fontWeight: 800,
                      ...toneTile(connected ? 'green' : 'orange')
                    }}>
                    {index + 1}
                  </Box>
                  <Typography sx={{ fontSize: 14 }}>{step}</Typography>
                </Box>
              ))}
            </SectionCard>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
export default withTranslation()(Payment)
